import {
  GET_ASN_GRN_DEPENDENCY_FAILURE,
  GET_ASN_GRN_DEPENDENCY_REQUEST,
  GET_ASN_GRN_DEPENDENCY_SUCCESS,
} from "./asnGrnDependencyTypes";

const initialStateForGetASN = {
  loading: false,
  dependency: [],
  error: "",
};

const getAsnGrnDependencyReducer = (state = initialStateForGetASN, action) => {
  switch (action.type) {
    case GET_ASN_GRN_DEPENDENCY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ASN_GRN_DEPENDENCY_SUCCESS:
      return {
        loading: false,
        dependency: action.payload,
        error: "",
      };
    case GET_ASN_GRN_DEPENDENCY_FAILURE:
      return {
        loading: false,
        dependency: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export { getAsnGrnDependencyReducer };
